module.exports = __webpack_public_path__ + "static/media/Niveau_elN15_0_520991.47375ab9.png";